import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LoadingSpinner } from "../components/common/LoadingSpinner";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { AdLayout } from "../components/layout/AdLayout";
import Home from "../pages/Home";
import Browse from "../pages/Browse";
import Search from "../pages/Search";
import MovieDetail from "../pages/MovieDetail";
import TVShowDetail from "../pages/TVShowDetail";
import Profile from "../pages/Profile";
import Watchlist from "../pages/Watchlist";
import ActorFilmography from "../pages/ActorFilmography";
import Contact from "../pages/Contact";
import FAQ from "../pages/FAQ";
import LegalNotice from "../pages/LegalNotice";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";
import NotFound from "../pages/NotFound";
import Blog from "../pages/Blog";
import WriteBlog from "../pages/WriteBlog";
import BlogPostDetail from "../pages/BlogPostDetail";
import NewBlogPost from "../pages/NewBlogPost";
import Login from "../pages/Login";
import Register from "../pages/Register";
import ComingSoon from "../pages/ComingSoon";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  // Si l'utilisateur n'est pas connecté, on le redirige vers la page de connexion
  if (!user) {
    // Sauvegarder la page actuelle pour rediriger l'utilisateur après la connexion
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Si l'utilisateur est connecté, on affiche le contenu protégé
  return <>{children}</>;
};

export const AppRoutes = () => (
  <Routes>
    {/* Public Routes */}
    <Route path="/" element={<AdLayout><Home /></AdLayout>} />
    <Route path="/browse" element={<AdLayout><Browse /></AdLayout>} />
    <Route path="/search" element={<AdLayout><Search /></AdLayout>} />
    <Route path="/movie/:id" element={<AdLayout><MovieDetail /></AdLayout>} />
    <Route path="/tv/:id" element={<AdLayout><TVShowDetail /></AdLayout>} />
    <Route path="/person/:id" element={<AdLayout><ActorFilmography /></AdLayout>} />
    <Route path="/faq" element={<AdLayout><FAQ /></AdLayout>} />
    <Route path="/legal-notice" element={<AdLayout><LegalNotice /></AdLayout>} />
    <Route path="/terms" element={<AdLayout><TermsOfService /></AdLayout>} />
    <Route path="/privacy" element={<AdLayout><PrivacyPolicy /></AdLayout>} />
    <Route path="/cookies" element={<AdLayout><CookiePolicy /></AdLayout>} />
    <Route path="/blog" element={<AdLayout><Blog /></AdLayout>} />
    <Route path="/blog/new" element={<AdLayout><NewBlogPost /></AdLayout>} />
    <Route path="/blog/:id" element={<AdLayout><BlogPostDetail /></AdLayout>} />
    <Route path="/login" element={<AdLayout><Login /></AdLayout>} />
    <Route path="/register" element={<AdLayout><Register /></AdLayout>} />
    <Route path="/coming-soon" element={<AdLayout><ComingSoon /></AdLayout>} />

    {/* Protected Routes */}
    <Route
      path="/write-blog"
      element={
        <PrivateRoute>
          <AdLayout><WriteBlog /></AdLayout>
        </PrivateRoute>
      }
    />
    <Route
      path="/profile"
      element={
        <PrivateRoute>
          <AdLayout><Profile /></AdLayout>
        </PrivateRoute>
      }
    />
    <Route
      path="/watchlist"
      element={
        <PrivateRoute>
          <AdLayout><Watchlist /></AdLayout>
        </PrivateRoute>
      }
    />
    <Route
      path="/contact"
      element={
        <PrivateRoute>
          <AdLayout><Contact /></AdLayout>
        </PrivateRoute>
      }
    />

    {/* 404 Route */}
    <Route path="*" element={<AdLayout><NotFound /></AdLayout>} />
  </Routes>
);
